// extracted by mini-css-extract-plugin
export default {"products":"GA-z","card":"HA-z","oosMessaging":"IA-z"};